import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_AVAILABLE_DOCUMENT_OBJECT_IDS: createActionType(FULL_NAMESPACE, "GET_AVAILABLE_DOCUMENT_OBJECT_IDS"),
    GET_AVAILABLE_DOCUMENT_OBJECT_IDS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_AVAILABLE_DOCUMENT_OBJECT_IDS_COMPLETED"),
    SET_SELECTED_DOCUMENT_OBJECT_IDS: createActionType(FULL_NAMESPACE, "SET_SELECTED_DOCUMENT_OBJECT_IDS"),
    GET_DOCUMENT_TABLE_DATA: createActionType(FULL_NAMESPACE, "GET_DOCUMENT_TABLE_DATA"),
    GET_DOCUMENT_TABLE_DATA_COMPLETED: createActionType(FULL_NAMESPACE, "GET_DOCUMENT_TABLE_DATA_COMPLETED"),
    SET_NODE_SOURCES: createActionType(FULL_NAMESPACE, "SET_NODE_SOURCES"),
    UPDATE_TABLE_DATA: createActionType(FULL_NAMESPACE, "UPDATE_TABLE_DATA"),
    CLEAR_DATA: createActionType(FULL_NAMESPACE, "CLEAR_DATA"),
    SET_DETAILED_PANEL_OPEN: createActionType(FULL_NAMESPACE, "SET_DETAILED_PANEL_OPEN"),
    SAVE_DOCUMENT_TABLE_DATA: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT_TABLE_DATA"),
    SAVE_DOCUMENT_TABLE_DATA_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_DOCUMENT_TABLE_DATA_COMPLETED"),
    GET_NODE_SOURCES: createActionType(FULL_NAMESPACE, "GET_NODE_SOURCES"),
    GET_NODE_SOURCES_COMPLETED: createActionType(FULL_NAMESPACE, "GET_NODE_SOURCES_COMPLETED"),
    SET_TABLE_FILTERS: createActionType(FULL_NAMESPACE, "SET_TABLE_FILTERS"),
    SET_TABLE_SORT_OPTIONS: createActionType(FULL_NAMESPACE, "SET_TABLE_SORT_OPTIONS")
};
